import s from './RadioButton.module.scss';
import { forwardRef } from 'react';

const RadioButton = forwardRef(({ id, name, text, checked, onChange }, ref) => {
  return (
    <label
      htmlFor={id}
      className={`${s.label} tabButton rectangleTab whiteTab`}
    >
      <input
        ref={ref}
        type="radio"
        id={id}
        name={name}
        checked={checked}
        onChange={onChange}
      />
      <span>{text}</span>
    </label>
  );
});

RadioButton.displayName = 'RadioButton';

export default RadioButton;
